exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-client-survey-source-form-cssf-sections-styles__centeredColumns {\n  display: flex;\n  align-items: flex-start;\n}\n\n@media only screen and (max-width: 599px) and (orientation: portrait),\n  screen and (max-height: 599px) and (orientation: landscape) {\n  .src-client-survey-source-form-cssf-sections-styles__centeredColumns {\n    display: block;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"centeredColumns": "src-client-survey-source-form-cssf-sections-styles__centeredColumns"
};